// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__g631S","name":"ConsentHeader_name__2pZOq","birthday":"ConsentHeader_birthday__15_uD","skeleton":"ConsentHeader_skeleton__ey2xz"};